export default __webpack_public_path__ + "static/media/arrow-down.ff289bed.svg";